import { GlTooltipDirective, GlButton, GlDisclosureDropdown, GlDisclosureDropdownItem, GlDisclosureDropdownGroup, GlToastMixin } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, sprintf } from '~/locale';
import EmojiPicker from '/builds/gitlab/gitlab-ee/app/assets/javascripts/emoji/components/picker.vue?vue3';
import AbuseCategorySelector from '/builds/gitlab/gitlab-ee/app/assets/javascripts/abuse_reports/components/abuse_category_selector.vue?vue3';
import UserAccessRoleBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/user_access_role_badge.vue?vue3';
import { WIKI_CONTAINER_TYPE } from '~/wikis/constants';
import discussionToggleResolveMutation from '../graphql/discussion_toggle_resolve.mutation.graphql';
export default {
    i18n: {
        buttonText: __('Reply to comment'),
        editCommentLabel: __('Edit comment'),
        deleteCommentLabel: __('Delete comment'),
        moreActionsLabel: __('More actions'),
        reportAbuse: __('Report abuse')
    },
    name: 'NoteActions',
    components: {
        UserAccessRoleBadge,
        GlButton,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlDisclosureDropdownGroup,
        AbuseCategorySelector,
        EmojiPicker
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        GlToastMixin
    ],
    inject: [
        'containerName',
        'containerType',
        'pageAuthorEmail'
    ],
    props: {
        authorId: {
            type: String,
            required: true
        },
        authorEmails: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        showReply: {
            type: Boolean,
            required: false,
            default: false
        },
        showEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        canReportAsAbuse: {
            type: Boolean,
            required: false,
            default: false
        },
        noteUrl: {
            type: String,
            required: false,
            default: ''
        },
        accessLevel: {
            type: String,
            required: false,
            default: ''
        },
        canAwardEmoji: {
            type: Boolean,
            required: false,
            default: false
        },
        canResolve: {
            type: Boolean,
            required: false,
            default: false
        },
        isResolved: {
            type: Boolean,
            required: false,
            default: false
        },
        discussionId: {
            type: String,
            required: false,
            default: ''
        },
        resolvedBy: {
            type: Object,
            required: false,
            default: null
        }
    },
    emits: [
        'award-emoji',
        'delete',
        'edit',
        'reply'
    ],
    data () {
        return {
            isReportAbuseDrawerOpen: false,
            loading: false
        };
    },
    computed: {
        showActionsDropdown () {
            return true;
        },
        showMemberBadge () {
            return Boolean(this.accessLevel);
        },
        showAuthorBadge () {
            return this.authorEmails.includes(this.pageAuthorEmail);
        },
        displayMemberBadgeText () {
            return sprintf(this.containerType === WIKI_CONTAINER_TYPE.PROJECT ? __('This user has the %{access} role in the %{name} project.') : __('This user has the %{access} role in the %{name} group.'), {
                access: this.accessLevel.toLowerCase(),
                name: this.containerName
            });
        },
        resolveIcon () {
            if (!this.loading) {
                return this.isResolved ? 'check-circle-filled' : 'check-circle';
            }
            return null;
        },
        resolveButtonTitle () {
            if (!this.isResolved) {
                return __('Resolve thread');
            }
            if (this.resolvedBy) {
                return sprintf(__('Resolved by %{name}'), {
                    name: this.resolvedBy.name
                });
            }
            return __('Resolved');
        }
    },
    methods: {
        toggleAbuseDrawer (val) {
            this.isReportAbuseDrawerOpen = val;
        },
        handleCopyLink () {
            this.$toast?.show(__('Link copied to clipboard.'));
        },
        async onResolve () {
            this.loading = true;
            try {
                await this.$apollo.mutate({
                    mutation: discussionToggleResolveMutation,
                    variables: {
                        id: this.discussionId,
                        resolve: !this.isResolved
                    }
                });
            } finally{
                this.loading = false;
            }
        }
    }
};
